import { getConversationById } from '@app/helpers'
import { ConversationItem } from '@app/models'

import { ChatState, CleanMessagesSuccessPayload } from '../types'

export const onCleanMessages = (
  state: ChatState,
  { id }: CleanMessagesSuccessPayload
): ChatState => {
  const conversation = getConversationById(state.conversations, id)
  if (!conversation) {
    return state
  }

  const lastMessage = conversation.messages.shift()

  const conversations: Record<number, ConversationItem> = {
    ...state.conversations,
    [id]: {
      ...conversation,
      messages: lastMessage ? [lastMessage] : [],
      total: 0,
    },
  }

  return {
    ...state,
    conversations,
  }
}
